import anime from 'animejs';

export function arrowButtonInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const arrow = ctx.querySelectorAll('.content__arrow-rotation');
  const text = ctx.querySelectorAll('.content__text');

  anime.set(arrow, { translateX: '-50%', opacity: 0 });
  anime.set(text, { translateY: 30, opacity: 0 });
}

export function arrowButtonAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const arrow = ctx.querySelectorAll('.content__arrow-rotation');
  const text = ctx.querySelectorAll('.content__text');
  const tl = anime.timeline();
  tl.add({
    targets: text,
    translateY: 0,
    opacity: 1,
    duration: 1000,
    easing: 'easeOutCirc',
  }, delay)
    .add({
      targets: arrow,
      translateX: 0,
      opacity: 1,
      duration: 600,
      easing: 'easeOutCirc',
    }, delay + 600);

  return tl;
}
